export default __webpack_public_path__ + "static/eds-map-3-0510baf1aa2802ed39a269b20850bf7a.gif";